import React from "react";
import { fetchQuery, graphql, useRelayEnvironment } from "react-relay";

const refetchMeetingRecordingQuery = graphql`
	query useRefetchMeetingRecordingQuery($id: ID!) {
		node(id: $id) {
			__typename
			... on MeetingRecording {
				...MeetingContent_meetingRecording @relay(mask: false)
			}
		}
	}
`;

/**
 * Hook that provides a function to refetch meeting recording data.
 *
 * @returns A function that takes a meeting recording ID and refetches its data using fetchQuery
 */
export function useRefetchMeetingRecording() {
	const environment = useRelayEnvironment();

	const refetchMeetingRecording = React.useCallback(
		(id: string) => {
			return fetchQuery(environment, refetchMeetingRecordingQuery, { id }).toPromise();
		},
		[environment],
	);

	return refetchMeetingRecording;
}
